import { Card, CardContent, SxProps, Theme, Typography } from "@mui/material";
import { bkdp } from "../theme";

type SimpleCardProps = {
  eyebrow?: string;
  title: string;
  text: string;
  sx?: SxProps<Theme>;
};

export function SimpleCard({ eyebrow, title, text, sx }: SimpleCardProps) {
  return (
    <Card sx={{ borderRadius: "10px", ...sx }}>
      <CardContent sx={{ px: 3.5, py: 3 }}>
        {eyebrow && (
          <Typography
            variant="overline"
            sx={{ color: bkdp.signalBlue, display: "block", mb: 1.25 }}
          >
            {eyebrow}
          </Typography>
        )}
        <Typography variant="h6" sx={{ mb: 1.25, color: bkdp.deepNavy }}>
          {title}
        </Typography>
        <Typography variant="body2" sx={{ color: bkdp.textBody }}>
          {text}
        </Typography>
      </CardContent>
    </Card>
  );
}
